import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';

import { GetTimestampFromTime } from '@dave/types';
import { TravelZoneActionTypes } from '../State/actions/travel-zone.actions';
import { getTravelZoneLatestUpdatedAt, getTravelZonesFetched } from '../State/selectors/travel-zone.selector';
import { BaseEntityReloadResolver2 } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class TravelZoneResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getTravelZonesFetched, getTravelZoneLatestUpdatedAt, TravelZoneActionTypes.LoadRequest, store, (d) => GetTimestampFromTime(d) + '');
    }
}
